export default __webpack_public_path__ + "static/media/bg-golf-course.8d2b0b4c.jpg";